import { Component, OnInit, ViewChild } from '@angular/core';
import { PanelMemberService } from 'src/app/shared/panel-member.service';
import { PanelMember } from 'src/app/model/panel-member.model';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { PanelMemberComponent } from 'src/app/main-content/panel-member/panel-member.component';
import { Http } from '@angular/http';
import { ApiService } from 'src/app/shared/api.service';
import { Headers, RequestOptions } from '@angular/http';
import * as XLSX from 'xlsx';
import { UploadExcelComponent } from 'src/app/main-content/panel-member/upload-excel/upload-excel.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NotificationService } from 'src/app/shared/notification.service';
import { DialogService } from 'src/app/shared/dialog-service/dialog.service';
import { UploadService } from 'src/app/shared/upload.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { GlobalConstantsService } from 'src/app/shared/global-constants.service';

@Component({
  selector: 'app-panel-member-list',
  templateUrl: './panel-member-list.component.html',
  styleUrls: ['./panel-member-list.component.scss']
})
export class PanelMemberListComponent implements OnInit {

  status: boolean = false;
  percentCompleted: number = 0;
  isSingleUploaded = false;
  percentUploaded = [0];
  acceptedExtensions = "csv, xls, xlsx";

  filterName: string;
  listData: MatTableDataSource<any>;
  private DialogRef: MatDialogRef<PanelMemberComponent>;
  private XlDialogRef: MatDialogRef<UploadExcelComponent>;
  private panelMembers: PanelMember[];
  uploadForm: FormGroup;
  private panelMemberJson: String;
  private apiDomain = ApiService.getDomainName();
  private eventId = this.apiService.getEventId();

  displayedColumns: string[] = ['panelMemberName', 'email', 'contactNo', 'actions'];

  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private http: Http,
    private panelMemberService: PanelMemberService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private fuService: UploadService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.getAllPanelMember();
    this.uploadForm = this.formBuilder.group({
      panelMemberFile: ['']
    });
  }
  getAllPanelMember() {
    this.panelMemberService.findAll().then(
      panelMembers => {
        this.panelMembers = panelMembers;
        if (this.panelMembers && Array.isArray(this.panelMembers)) {
          this.listData = new MatTableDataSource(panelMembers);
          this.listData.sort = this.sort;
          this.listData.paginator = this.paginator;
        } else {
          this.listData = undefined;
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  applyFilter(filterValue: string) {
    if (this.listData) {
      this.listData.filter = filterValue.trim().toLowerCase();
    }
  }
  onClear() {
    this.listData.filter = '';
    this.filterName = '';
    this.notificationService.success('Cleared');
  }

  onCreate() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "50%";
    this.DialogRef = this.dialog.open(PanelMemberComponent, dialogConfig);
    const subscribeRef = this.DialogRef
                            .componentInstance
                            .fetchPanelMembers
                            .subscribe(fetchStatus =>
                              fetchStatus
                              ? this.getAllPanelMember()
                              : null)

    this.DialogRef
      .afterClosed()
      .subscribe(() => subscribeRef.unsubscribe());
  }

  onUpload() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "40%";
    this.XlDialogRef = this.dialog.open(UploadExcelComponent, dialogConfig);
    const subscribeRef = this.XlDialogRef
                            .componentInstance
                            .fetchPanelMembers
                            .subscribe(fetchStatus =>
                              fetchStatus
                              ? this.getAllPanelMember()
                              : null);
    this.XlDialogRef.afterClosed().subscribe(() => subscribeRef.unsubscribe());
  }

  onEdit(rowId) {
    for (let panelMember of this.panelMembers) {
      if (panelMember['panelMemberId'] == rowId) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = "50%";
        this.panelMemberService.form.controls['id'].setValue(panelMember['panelMemberId']);
        this.panelMemberService.form.controls['fullName'].setValue(panelMember['panelMemberName']);
        this.panelMemberService.form.controls['email'].setValue(panelMember['email']);
        this.panelMemberService.form.controls['mobile'].setValue(panelMember['contactNo']);
        this.DialogRef = this.dialog.open(PanelMemberComponent, dialogConfig);
        const subscribeRef = this.DialogRef
                                .componentInstance
                                .fetchPanelMembers
                                .subscribe(fetchStatus =>
                                  fetchStatus
                                  ? this.getAllPanelMember()
                                  : null)
    
        this.DialogRef
          .afterClosed()
          .subscribe(() => subscribeRef.unsubscribe());

      }
    }
  }

  onDelete(rowId) {
    this.dialogService.openConfirmDialog('Are you sure to delete this record ?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.panelMemberService.deletePanelMember(rowId)
            .then(data => {
              this.getAllPanelMember();
              this.notificationService.success(data);
            }).catch(err => {
              this.notificationService.warn(err);
            });
        }
      });
  }

  csvInputChange(files) {
    // var files = fileInputEvent.target.files; // FileList object
    if(!(files[0].name.indexOf(".xlsx") > 0)){
      this.notificationService.warn('Only .xlsx & .xls extensions file can be acceptable');
      return false;
    }
    this.parseExcel(files[0]);
  }

  parseExcel(file) {
    console.log(file.name);
    this.isSingleUploaded = false;
    var reader = new FileReader();
    reader.onload = (e) => {
      var data = (<any>e.target).result;
      var workbook = XLSX.read(data, {
        type: 'binary'
      });
      workbook.SheetNames.forEach((function (sheetName) {
        // Here is your object
        var XL_row_object = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { raw: false });

        if (XL_row_object &&
          Array.isArray(XL_row_object) &&
          (XL_row_object.length > 0)
        ) {
          const panelMemberXLVariableObjectList: Array<JSON> | null = GlobalConstantsService.XLTitleVariableMapper(XL_row_object, 'PANEL-MEMBER');
          // var json_object = JSON.stringify(panelMemberXLVariableObjectList);
          this.panelMemberService.createPanelMember(panelMemberXLVariableObjectList).then(
            res => {
              this.notificationService.success((res && res.data && res.data.message) || 'File uploaded Successfully');
            },
            err => {
              if(err && err.errors && Array.isArray(err.errors)) {
                const errorList = err.errors;
                errorList.forEach(errorObj => {
                  this.notificationService.warn(errorObj.message); 
                });
              }
              return false;
            }
          );
          // console.log(panelMemberXLVariableObjectList)
  
        } else {
          console.debug(XL_row_object);
          this.notificationService.warn('XLSX format is not proper.');
        }
        //this.gridObj.dataSource = JSON.parse(json_object);
      }).bind(this), this);
    }

    reader.onerror = function (ex) {
      console.log(ex);
    }
    reader.readAsBinaryString(file);
    console.log
  }

  createPanelMember(json_object) {
    let panelHeaders = new Headers({ 'Content-Type': 'application/json', 'authorization': this.apiService.getStringifySessionObj() });
    return this.http.post(this.apiDomain + "/ims/api/" + this.eventId + "/panelMember/", json_object, { headers: panelHeaders })
      .toPromise()
      .then(response => response as any)
      .catch(this.handleError);
  }
  private handleError(error: any) {
    console.error('An error occurred', error);
    try {
       const errorJSON = error && error.json();
      if ( errorJSON.httpCode == 401 ) {
        ApiService.sessionExpireRedirection();
      }
      return Promise.reject(errorJSON);
    } catch(err) {
      return Promise.reject(error && error.message);
    }
  }
}
